@let blok = block();

<button (click)="drawer.toggle($event)"
        class="border solid border-grey py-1 px-6 rounded-full hover:bg-grey transition duration-200 ease-in"
        [ngClass]="getButtonAlignClasses()"
        appTooltip
        [tooltipDisabled]="!blok.drawerTextContent"
        [tooltip]="blok.drawerTextContent || ''"
        position="below">
  {{blok.buttonText}}
</button>

<div class="md:hidden"
     app-drawer
     [isActive]="drawerActive()"
     (isActiveChange)="drawerActive.set($event)"
     #drawer>
    <p>
        {{blok.drawerTextContent}}
    </p>
</div>
